import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useSelector } from 'react-redux';
import { Box } from 'roo-ui/components';
import { getIsDomestic } from 'store/property/propertySelectors';
import ResultsFetcher from './ResultsFetcher';
import Properties from './Properties/Properties';
import TreatmentToggle from 'components/TreatmentToggle';

const RecommendedProperties = React.memo(() => {
  const isDomestic = useSelector(getIsDomestic);
  const [ref, inView] = useInView({ triggerOnce: true });

  if (!isDomestic) return null;

  return (
    <Box ref={ref}>
      {inView && (
        <TreatmentToggle split="property_page_recommendations" treatment={['popular_properties', 'related_properties']}>
          <ResultsFetcher />
          <Properties />
        </TreatmentToggle>
      )}
    </Box>
  );
});

RecommendedProperties.displayName = 'RecommendedProperties';

export default RecommendedProperties;
